<template>
  <div>
    <card>
        <div class="row" style="margin-bottom:10px">
            <div class="col">
                <router-link to="crea-cliente"><button class="btn float-left" type="button" style="background:#00467f">CREA CLIENTE</button></router-link>
            </div>
            <!-- <div class="col">
                <button @click="showSearch = !showSearch" class="btn float-right" type="button" style="margin-top:10px;background:#00467f">Cerca Cliente</button>
            </div> -->
        </div>
        <table class="table tablesorter" id="tabella" style="text-align: center">
            <thead>
                <tr>
                    <th></th>
                    <th>Codice Fiscale</th>
                    <th>Partita IVA</th>
                    <th>Denominazione</th>
                    <th>Profilo di rischio</th>
                    <th>AV</th>
                    <th>Periodicità</th>
                    <th>Data ultima AV</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr class="row-color" v-for="valori in allClienti" v-bind:key="valori.ID"> <!---->
                    <td @click="caricaCliente(valori.ID)">
                        <i class="tim-icons icon-pencil" style="color:#00467f"></i>
                    </td>
                    <td v-if="valori.TAB_A != null" @click="goToRiassuntoPage(valori.ID)" style="cursor: pointer;">{{valori.CF}}</td>
                    <td v-else>{{valori.CF}}</td>
                    <td>{{valori.PIVA}}</td>
                    <td>{{valori.DENOMINAZIONE}}</td>
                    <td>{{valori.PROFILO_RISCHIO}}</td>
                    <td>{{valori.ADEGUATA_VERIFICA}}</td>
                    <td>{{valori.AV_PERIODICITA_MESI}}</td>
                    <td v-if="valori.AV_DATA != null">{{getDate(valori.AV_DATA)}}</td>
                    <td v-else></td>
                    <!-- <td><button v-on:click="caricaCliente(valori.ID)"><i class="tim-icons icon-pencil" style="color:#00467f"></i></button></td> -->
                    <td>
                        <!-- <i class="fa-regular fa-circle-a"></i> -->
                        <span v-if="valori.TAB_A == null">
                            <router-link :to="'valutazione-a?idCliente='+valori.ID">
                                <!-- <img src="@/assets/img/red.png" style="width:20px"> -->
                                <i class="fa fa-font" style="font-size:16px;color:red"></i>
                            </router-link>
                        </span>
                        <span v-else>
                            <!-- <img src="@/assets/img/green.png" style="width:20px"> -->
                            <router-link :to="'valutazione-a?idCliente='+valori.ID+'&idTabA='+valori.TAB_A">
                                <i class="fa fa-font" style="font-size:16px;color:green"></i>
                           </router-link>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        
    </card>
    <hr>
    <b-modal v-model="showSearch"  size="md">
        <template #modal-header="{ close }">
            <b-button size="sm"  style="background:#00467f;" @click="close()">X</b-button>
        </template>
        <template>
            <h3 style="color:black">Cerca cliente</h3>
            <form>
                <div class="row">
                    <div class="col">
                        <label for="codice_fiscale"><strong>CODICE FISCALE</strong></label>
                        <input class="form-control" type="codice_fiscale" placeholder="codice_fiscale" name="codice_fiscale" v-model="codice_fiscale_search" v-on:change="cercaInfo()">
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label for="denominazione"><strong>DENOMINAZIONE </strong></label>
                        <input class="form-control" type="denominazione" placeholder="denominazione" name="denominazione" v-model="denominazione_search" v-on:change="cercaInfo()">
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label for="partita_iva"><strong>PARTITA IVA</strong></label>
                        <input class="form-control" type="text" placeholder="partita_iva" name="partita_iva" v-model="partita_iva_search" v-on:change="cercaInfo()">
                    </div>
                </div>
            </form> 
            <div v-show="showRisultati">
                <div v-if="cerca_info.length>0">
                    <table class="table tablesorter" style="text-align: center;">
                        <thead>
                        <tr>
                            <th>AZIENDA</th>
                            <th>CF</th>
                            <th>P. IVA</th>
                            <th>SEDE</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(valori,index) in cerca_info" v-bind:key="valori.ID">
                            <td style="text-decoration:underline"><a v-on:click="compilaForm(index)">{{valori.name}}</a></td>
                            <td>{{valori.crm_cf_c}}</td>
                            <td>{{valori.crm_piva_c}}</td>
                            <td>{{valori.billing_address_street}}, {{valori.billing_address_city}} ({{valori.billing_address_state}}) {{valori.billing_address_postalcode}}</td><!--infoAzienda.billing_address_street + ", " + infoAzienda.billing_address_city + " (" + infoAzienda.billing_address_state + ") " +infoAzienda.billing_address_postalcode -->
                        </tr>
                        </tbody>
                    </table>
                    </div>
            </div>
        </template>
        <template #modal-footer="{ cancel }">
            <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">CHIUDI</b-button></span>
            <span style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="cerca()">CERCA</b-button></span>
        </template>
    </b-modal>

    <card v-if="idCliente != null">
        <!-- <div class="row">
            <a :href="urlRichieste + ''" target="_blank" style="color:white;font-weight: bold;margin-left:10px"><button class="btn float-left" type="button" style="margin-bottom: 10px;background:#00467f">Scarica documenti</button></a>
        </div>         -->
        <div class="row">
            <b-dropdown id="dropdown" text="Scarica documenti AV" class="m-md-2" variant="confcommercio" style="float-left"><!-- class="m-md-2" -->
                <b-dropdown-item v-on:click="downloadAVFunction('AV1.docx')">AV1</b-dropdown-item>
                <b-dropdown-item v-on:click="downloadAVFunction('AV2.docx')">AV2</b-dropdown-item>
                <b-dropdown-item v-on:click="downloadAVFunction('AV3.docx')">AV3</b-dropdown-item>
                <b-dropdown-item v-on:click="downloadAVFunction('AV4.docx')">AV4</b-dropdown-item>
                <b-dropdown-item v-on:click="downloadAVFunction('AV5.docx')">AV5</b-dropdown-item>
                <b-dropdown-item v-on:click="downloadAVFunction('AV6.docx')">AV6</b-dropdown-item>
                <b-dropdown-item v-on:click="downloadAVFunction('AV7.docx')">AV7</b-dropdown-item>
                <!-- <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item active>Active action</b-dropdown-item>
                <b-dropdown-item disabled>Disabled action</b-dropdown-item> -->
            </b-dropdown>
        </div>
        <form>
            <h3>Dati Identificativi</h3>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="codice_fiscale">Codice Fiscale<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="codice_fiscale" placeholder="codice_fiscale">
                </div>
                <div class="form-group col-md-4">
                    <label for="p_iva">Partita IVA<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="p_iva" placeholder="0899123">
                </div>
                <div class="form-group col-md-4">
                    <label for="nome">Cognome Nome/Denominazione<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="nome" placeholder="Cognome Nome/Denominazione">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="attivita_svolta">Attività svolta<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="attivita_svolta" placeholder="attivita_svolta">
                </div>
                <div class="form-group col-md-4">
                    <label for="natura_giuridica">Natura giuridica<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="natura_giuridica" placeholder="..">
                </div>
                <div class="form-group col-md-4">
                    <label for="data_fine_rapporto">Data Fine Rapporto:</label>
                    <input type="date" class="form-control" v-model="data_fine_rapporto">
                </div>
            </div>
            
            <hr>
            <h3 style="margin-top:10px">Sede legale</h3>
            <div class="form-row">
                <div class="form-group col-md-3">
                    <label for="indirizzo">Indirizzo<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="indirizzo" placeholder="indirizzo">
                </div>
                <div class="form-group col-md-3">
                    <label for="comune">Comune<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="comune" placeholder="..">
                </div>
                <div class="form-group col-md-3">
                    <label for="cap">CAP<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="cap">
                </div>
                <div class="form-group col-md-3">
                    <label for="provincia">Provincia<span style="color:#ff0000">*</span></label>
                    <!-- <input type="text" class="form-control" v-model="provincia"> -->
                    <select v-model="provincia" class="form-control">
                        <option disabled value="">Seleziona una provincia</option>
                        <option v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value">{{val.text}}</option>
                    </select>
                </div>
            </div>
            <hr>
            <h3 style="margin-top:10px">Altri Dati</h3>
            <div class="form-row">
                <div class="form-group col-md">
                    <label for="note">Note</label>
                    <textarea lass="form-control" v-model="note" id="note" rows="3" style="width:100%;border-radius:7px"></textarea>
                </div>
            </div>
            <h3 style="margin-top:10px">Dati Antiriciclaggio</h3>
            <div class="form-row">
                <!-- <div class="form-group col-md-4">
                    <label for="nuovo_cliente">Nuovo cliente</label>
                    <input type="checkbox" class="form-control" id="nuovo_cliente" v-model="value_cliente">
                </div> -->
                <div class="form-group col-md-4">
                    <label for="nuovo_cliente">Nuovo cliente</label>
                    <input type="radio" class="form-control" id="nuovo_cliente" value="NUOVO_CLIENTE" v-model="value_cliente">
                </div>
                <div class="form-group col-md-4">
                    <label for="gia_cliente">Cliente già identificato in relazione ad un precedente incarico professionale</label>
                    <input type="radio" class="form-control" id="gia_cliente" value="GIA_CLIENTE" v-model="value_cliente">
                </div>
                <div class="form-group col-md-4">
                    <label for="necessari_dati">Necessaria/opportuna una nuova identificazione per variazione e/o verifica dei dati Identificativi</label>
                    <input type="radio" class="form-control" id="necessari_dati" value="NECESSARI_DATI" v-model="value_cliente">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label>Data prima identificazione</label>
                    <input type="date" class="form-control" v-model="data_prima_identificazione">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group">
                    <h3 for="file" style="margin-bottom:20px">Carica visura<span style="color:#ff0000">*</span></h3>
                    <button class="btn" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()" accept=".jpg,.jpeg,.png,.pdf"></button>
                </div>
            </div>
            <div class="row justify-content-start" style="margin-top:10px;">
                <div class="col">
                    <div v-if="cliente[0].ANTIRIC_CLIENTE_META.length > 0" style="margin-top:15px">
                        <p>File caricati:</p>
                        <div v-for="value in cliente[0].ANTIRIC_CLIENTE_META" v-bind:key="value.ID">
                            <p v-if="value.TYPE == 'DOCUMENT'"><a :href="'https://sviluppoallergeni.confcom.it'+  value.VALUE.url  + '?token='+access_token" target="_blank" style="color:black">{{value.VALUE.name}}</a> (Visura)</p>
                        </div>
                        <div v-for="value in cliente[0].ANTIRIC_CLIENTE_META" v-bind:key="value.ID">
                            <p v-if="value.TYPE != 'DOCUMENT'"><a :href="'https://sviluppoallergeni.confcom.it'+  value.VALUE.url  + '?token='+access_token" target="_blank" style="color:black">{{value.VALUE.name}}</a> ({{value.TYPE}})</p>
                        </div>
                    </div>
                    <div v-else></div>
                </div>
                <div class="col"></div>
                <div class="col"></div>
            </div>
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva Modifiche</button>
        <router-link v-if="idTabA == null" :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link v-else :to="'valutazione-a?idCliente='+idCliente+'&idTabA='+idTabA"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        
        <!-- </div> --> 
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriResidenza()" style="margin-top: 10px;background:#00467f">Salva</button> -->
       
       <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal>
    </card>
  </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';
import moment from 'moment';

export default {
    components: {
        Card
    },

    data() {
        return {
            codice_fiscale: null,
            p_iva: null,
            nome: null,
            attivita_svolta: null,
            natura_giuridica: null,
            data_fine_rapporto: null,
            value_cliente: null,
            data_prima_identificazione: null,
            
            indirizzo: null,
            comune: null,
            cap: null,
            provincia: null,
            listaProvince: [
               { value: "AG", text: "AG	Agrigento"}, { value: "AL", text: "AL Alessandria"}, 
               { value: "AN", text: "AN	Ancona"}, { value: "AO", text: "AO	Aosta"}, {value: "AQ", text: "AQ L'Aquila"}, 
               { value: "AR", text: "AR Arezzo"}, { value: "AP", text: "AP	Ascoli-Piceno"}, {value: "AT", text: "AT Asti"}, 
               { value: "BA", text: "BA	Bari"}, { value: "BT", text: "BT Barletta-Andria-Trani"}, {value: "BL", text: "BL Belluno"}, 
               { value: "BN", text: "BN Benevento"}, { value: "BG", text: "BG Bergamo"}, {value: "BI", text: "BI Biella"}, 
               { value: "BO", text: "BO	Bologna"}, { value: "BZ", text: "BZ Bolzano"}, {value: "BS", text: "BS Brescia"}, 
               { value: "BR", text: "BR Brindisi"}, { value: "CA", text: "CA Cagliari"}, {value: "CL", text: "CL Caltanissetta"}, 
               { value: "CB", text: "CB	Campobasso"}, { value: "CI", text: "CI Carbonia Iglesias"}, {value: "CE", text: "CE Caserta"}, 
               { value: "CT", text: "CT	Catania"}, { value: "CZ", text: "CZ Catanzaro"}, {value: "CH", text: "CH Chieti"}, 
               { value: "CO", text: "CO Como"}, { value: "CS", text: "CS Cosenza"}, {value: "CR", text: "CR	Cremona"}, 
               { value: "KR", text: "KR Crotone"}, { value: "CN", text: "CN	Cuneo"}, {value: "EN", text: "EN Enna"}, 
               { value: "FM", text: "FM	Fermo"}, { value: "FE", text: "FE Ferrara"}, {value: "FI", text: "FI Firenze"},
                { value: "FG", text: "FG Foggia"}, { value: "FC", text: "FC Forli-Cesena"}, {value: "FR", text: "FR Frosinone"}, 
               { value: "GE", text: "GE	Genova"}, { value: "GO", text: "GO Gorizia"}, {value: "GR", text: "GR Grosseto"}, 
               { value: "IM", text: "IM	Imperia"}, { value: "IS", text: "IS Isernia"}, {value: "SP", text: "SP La-Spezia"},
               { value: "LT", text: "LT	Latina"}, { value: "LE", text: "LE Lecce"}, {value: "LC", text: "LC Lecco"}, 
               { value: "LI", text: "LI	Livorno"}, { value: "LO", text: "LO	Lodi"}, {value: "LU", text: "LU	Lucca"}, 
               { value: "MC", text: "MC	Macerata"}, { value: "MN", text: "MN Mantova"}, {value: "MS", text: "MS	Massa-Carrara"}, 
               { value: "MT", text: "MT	Matera"}, { value: "VS", text: " VS Medio Campidano"}, {value: "ME", text: "ME Messina"}, 
               { value: "MI", text: "MI	Milano"}, { value: "MO", text: "MO Modena"}, {value: "MB", text: "MB Monza-Brianza"}, 
               { value: "NA", text: "NA	Napoli"}, { value: "NO", text: " NO	Novara"}, {value: "NU", text: "NU Nuoro"}, 
               { value: "OG", text: "OG	Ogliastra"}, { value: "OT", text: "OT Olbia Tempio"}, {value: "OR", text: "OR Oristano"}, 
               { value: "PD", text: "PD	Padova"}, { value: "PA", text: "PA Palermo"}, {value: "PR", text: "PR Parma"}, 
               { value: "PV", text: "PV	Pavia"}, { value: "PG", text: "PG Perugia"}, {value: "PU", text: "PU Pesaro-Urbino"}, 
               { value: "PE", text: "PE Pescara"}, { value: "PC", text: "PC Piacenza "}, {value: "PI", text: "PI Pisa"}, 
               { value: "PT", text: "PT	Pistoia"}, { value: "PN", text: "PN	Pordenone"}, {value: "PZ", text: "PZ Potenza"}, 
               { value: "PO", text: "PO	Prato"}, { value: "RG", text: "RG Ragusa"}, {value: "RA", text: "RA	Ravenna"}, 
               { value: "RC", text: "RC	Reggio-Calabria"}, { value: "RE", text: "RE	Reggio-Emilia"}, {value: "RI", text: "RI Rieti"}, 
               { value: "RN", text: "RN	Rimini"}, { value: "Roma", text: "Roma Roma"}, {value: "RO", text: "RO	Rovigo"}, 
               { value: "SA", text: "SA	Salerno"}, { value: "SS", text: "SS	Sassari"}, {value: "SV", text: "SV Savona"}, 
               { value: "SI", text: "SI	Siena"}, { value: "SR", text: "SR Siracusa"}, {value: "SO", text: "SO Sondrio"}, 
               { value: "TA", text: "TA	Taranto"}, { value: "TE", text: "TE	Teramo"}, {value: "TR", text: "TR Terni"}, 
               { value: "TO", text: "TO	Torino"}, { value: "TP", text: "TP Trapani"}, {value: "TN", text: "TN Trento"}, 
               { value: "TV", text: "TV	Treviso "}, { value: "TS", text: "TS Trieste"}, {value: "UD", text: "UD	Udine"}, 
               { value: "VA", text: "VA	Varese"}, { value: "VE", text: "VE Venezia"}, {value: "VB", text: "VB	Verbania"}, 
               { value: "VC", text: "VC	Vercelli"}, { value: "VR", text: "VR Verona"}, {value: "VV", text: "VV Vibo-Valentia"}, 
               { value: "VI", text: "VI	Vicenza"}, { value: "VT", text: " VT	Viterbo"}
            ],

            note: null,

            cerca_info: [],
            showSearch: false,
            showRisultati: false,
            denominazione_search: null,
            codice_fiscale_search: null,
            partita_iva_search: null,

            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/',

            allClienti: [],
            cliente: [],
            idCliente: null,
            idTabA: null,

            showCheckFile: false,
            showLoader: false,
        }
    },
    methods: {
        cercaInfo: async function() {
            let errore = 0;
            //const token = localStorage.getItem('access_token');
            await axios.get(
                this.urlRichieste + 'azienda?filter=true&name='+this.denominazione_search+'&CF='+this.codice_fiscale_search+'&piva='+this.partita_iva_search,
                {
                    headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${this.access_token}`
                }
            }).then(response => { this.cerca_info = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.cercaInfo(); }
            }
            this.showRisultati = true;
        },

        caricaCliente: async function(id) {
            let errore = 0;
            await AntiriciclaggioServices.getCliente(id)
            .then(response => { this.cliente= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.caricaCliente(id); }
            }
            // console.log(`cliente:`);
            // console.log(this.cliente);
            this.codice_fiscale = this.cliente[0].CF;
            this.p_iva = this.cliente[0].PIVA;
            this.nome = this.cliente[0].DENOMINAZIONE;
            this.attivita_svolta = this.cliente[0].ATTIVITA_SVOLTA;
            this.natura_giuridica = this.cliente[0].NATURA_GIURIDICA;
            this.data_fine_rapporto = this.cliente[0].DATA_FINE_RAPPORTO;
            this.indirizzo = this.cliente[0].INDIRIZZO;
            this.comune = this.cliente[0].COMUNE;
            this.cap = this.cliente[0].CAP;
            this.provincia = this.cliente[0].PROVINCIA;
            this.nuovo_cliente = this.cliente[0].NUOVO_CLIENTE;
            /*this.data_prima_identificazione = this.cliente[0].DATA_PRIMA_IDENTIFICAZIONE; */
            this.idCliente = this.cliente[0].ID;
            this.idTabA = this.cliente[0].TAB_A;
        },

        checkData: function() {
            if (this.codice_fiscale == null || this.p_iva == null ||  this.nome == null || this.attivita_svolta == null || this.natura_giuridica == null //|| this.data_fine_rapporto == null
                    || this.value_cliente == null || this.indirizzo == null || this.comune == null || this.cap == null || this.provincia == null
                    || this.data_prima_identificazione == null ) {
                return false;
            } else {
                return true;
            }  
        },

        checkFileUpload: function() {
            this.showCheckFile = true;
        },

        downloadAVFunction: async function(documentName) {
            console.log(`documentName is: ` + documentName);
            let downloadResponse;
            let errore = 0;
            await AntiriciclaggioServices.downloadAV(documentName, this.idCliente)
            .then(response => { downloadResponse= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.downloadAVFunction(documentName); }
            }
            console.log(`downloadResponse:`);
            console.log(downloadResponse);
        },

        goToRiassuntoPage: function(id) {
            let path = 'riassunto?idCliente=' + id + '&update=false';
                this.$router.push({
                    path: path
                }) 
        },

        handleFileUpload: async function(){
            this.showLoader = true;
            // let token = localStorage.getItem('access_token');
            let risposta;
            let errore = 0;
            this.file = this.$refs.file.files[0];
            let formData = new FormData()
            formData.append('documento', this.file)
            await AntiriciclaggioServices.caricaDocumentoCliente(this.idCliente, formData)
            .then(response => { risposta = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                console.log(`errore 401`);
                let value = await Services.refreshTokenFunction();
                if (value) { await this.handleFileUpload(); }
            }
            this.showCheckFile = false;
            this.showLoader = false;
            await this.caricaCliente(this.idCliente);
        }, 

        getAllClienti: async function() {
            let errore = 0;
            await AntiriciclaggioServices.getAllClienti()
            .then(response => { this.allClienti= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getAllClienti(); }
            }
            console.log(`allClienti:`);
            console.log(this.allClienti);
        },

        getDate(date) {
            return moment(String(date)).format('DD/MM/YYYY');
        },

        salvaValoriDati: async function() {
            if (this.checkData()) {
                let dati = [];
                dati.push({ 
                    CF: this.codice_fiscale, PIVA: this.p_iva, DENOMINAZIONE: this.nome, ATTIVITA_SVOLTA: this.attivita_svolta, NATURA_GIURIDICA: this.natura_giuridica, 
                    DATA_FINE_RAPPORTO: this.data_fine_rapporto, NUOVO_CLIENTE: this.value_cliente, INDIRIZZO: this.indirizzo, COMUNE: this.comune, CAP: this.cap, 
                    PROVINCIA: this.provincia, NOTE: this.note, DATA_PRIMA_IDENTIFICAZIONE: this.data_prima_identificazione
                });
                let datiJSON=JSON.stringify(dati[0]);
                let salvaValori = [];
                let errore = 0; 
                await AntiriciclaggioServices.updateCliente(datiJSON, this.idCliente)
                .then(response => { salvaValori= response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                        errore = error.response.status;
                    }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriDati(); }
                }
                console.log(`salvaValori response`);
                console.log(salvaValori);
                let path = 'anagrafica-soggetti?idCliente=' + this.idCliente;
                this.$router.push({
                    path: path
                }) 
            } else {
                alert("Compilare tutti i campi!")
            }
            
        },

        main: async function() {
            axios.defaults.withCredentials = true;
            this.access_token = localStorage.getItem('access_token');
            try {
                await this.getAllClienti();
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                if (error.response.status == 401) {
                await Services.refreshTokenFunction();
                }
            }
        }
    },
    
    mounted() {
        this.main();
    }
};
</script>
<style scoped>
    label {
        font-size: 16px;
    }
    span {
        font-size: 100%;
    }
</style>
